var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"f-social-button d-flex justify-content-center gap-3"},[_c('img',{attrs:{"src":require("@/assets/google.png"),"alt":""}}),_vm._v(" Google ")])])
}]

export { render, staticRenderFns }